import React, { useState } from 'react';
import { FaTwitter, FaTelegramPlane, FaDiscord } from 'react-icons/fa';

export default function Footer() {
  const year = new Date().getFullYear();
  const [showPopup, setShowPopup] = useState(false);

  const handleDiscordClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 3000); // auto-hide after 3s
  };

  const XLogo = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      className="fill-current"
    >
      <path d="M17.53 2H21L13.91 10.34L22.36 22H15.67L10.45 14.94L4.52 22H1L8.58 13.05L0.64 2H7.5L12.24 8.44L17.53 2ZM16.3 20H18.43L6.97 4H4.69L16.3 20Z" />
    </svg>
  );
  

  return (
    <footer className="bg-gray-900 text-white font-mono py-8 relative overflow-hidden">
      {/* Glowing gradient backdrop */}
      <div className="absolute inset-0 animate-gradient-border blur-3xl opacity-20 pointer-events-none" />

      <div className="relative container mx-auto px-6 flex flex-col md:flex-row items-center md:items-start justify-between space-y-6 md:space-y-0 z-10">
        {/* Social icons */}
        <div className="flex space-x-4">
          <a
            href="https://x.com/Pr3dictionAr3na"
            target="_blank"
            rel="noopener noreferrer"
            className="neon-icon p-2 rounded-full transition-transform transform hover:scale-110"
            aria-label="Twitter"
          >
            <XLogo />
          </a>
          <a
            href="https://t.me/httpspredictionarenaofficial"
            target="_blank"
            rel="noopener noreferrer"
            className="neon-icon p-2 rounded-full transition-transform transform hover:scale-110"
            aria-label="Telegram"
          >
            <FaTelegramPlane size={24} />
          </a>
          <button
            onClick={handleDiscordClick}
            className="neon-icon p-2 rounded-full transition-transform transform hover:scale-110 focus:outline-none"
            aria-label="Discord"
          >
            <FaDiscord size={24} />
          </button>
        </div>

        {/* Copyright */}
        <div className="text-sm text-gray-500 text-center md:text-right">
          &copy; {year} Prediction Arena. All rights reserved.
        </div>
      </div>

      {showPopup && (
      <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none">
        <div className="mb-12 px-6 py-3 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white rounded-2xl shadow-xl backdrop-blur-md animate-fade-in-out pointer-events-auto">
          🚀 Discord server coming soon!
        </div>
      </div>
    )}

      {/* CSS */}
      <style jsx>{`
        .animate-gradient-border {
          background: conic-gradient(from 0deg, #8b5cf6, #ec4899, #ef4444, #8b5cf6);
          background-size: 200% 200%;
          animation: gradientShift 5s ease infinite;
        }
        .neon-icon {
          color: #fff;
          box-shadow: 0 0 4px rgba(255,255,255,0.3), 0 0 12px rgba(255,0,128,0.6);
        }

        @keyframes gradientShift {
          0% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
          100% { background-position: 0% 0%; }
        }

        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(20px) scale(0.95); }
          10%, 90% { opacity: 1; transform: translateY(0) scale(1); }
          100% { opacity: 0; transform: translateY(-10px) scale(0.95); }
        }

        .animate-fade-in-out {
          animation: fadeInOut 3s ease forwards;
        }
      `}</style>
    </footer>
  );
}
